import { useState } from "react";
import CustomButton from "../../../common/CustomButton";
import TextOptionTile from "../../../common/TextOptionTile";


function SlideSelectMinutesPerWeek(props) {
    // const mpw = ["None", "30 Mins", "60 Mins", "90 Mins", "120 Mins", "150+ Mins"];
    const mpw = [
        { "label": "None", "value": "0 Mins" },
        { "label": "30 Mins", "value": "30 Mins" },
        { "label": "60 Mins", "value": "60 Mins" },
        { "label": "90 Mins", "value": "90 Mins" },
        { "label": "120 Mins", "value": "120 Mins" },
        { "label": "150+ Mins", "value": "150+ Mins" },
    ]
    const [selectedMPW, setSelectedMPW] = useState("");

    const updateOptions = (m) => {
        setSelectedMPW(m)
    }

    let disable = selectedMPW === "";

    return (
        <div id="uo-select-minutes-per-week" className="uo-component">
            <div id="uo-mpw-form" className="ou-with-text">
                <h4>On average, how many minutes do you exercise per week?</h4>

                <div id="uo-mpw-f-minutes">
                    {
                        mpw.map((m, index) => {
                            return <TextOptionTile key={index} label={m?.label} onClick={() => {
                                updateOptions(m?.value);
                            }} isActive={selectedMPW == m?.value} />
                        })
                    }
                </div>

                <CustomButton disabled={disable} className="uo-button active" onClick={(e) => {
                    props?.moveNext();
                    props?.setPreRegistrationDetails(prd => ({
                        ...prd,
                        minutesPerWeek: selectedMPW,
                        consistency: selectedMPW == "0 Mins" ? "Be More Active" : ""
                    }));
                }}>Continue</CustomButton>
            </div>
        </div>
    );
}

export default SlideSelectMinutesPerWeek;